import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import {environment} from '../../environments/environment';

@Injectable()
export class AuthenticationService {
    public loggedIn: Subject<boolean> = new BehaviorSubject<boolean>(false);
    public employeeDisplayName: Subject<string> = new BehaviorSubject<string>("");
    public region: Subject<string> = new BehaviorSubject<string>("");
    constructor(private http: HttpClient) {
        if (localStorage.getItem('currentUser')) {
            // logged in so return true
            var curUser = JSON.parse(localStorage.getItem('currentUser'));
            this.loggedIn.next(true);
            this.region.next(curUser.region);
            this.employeeDisplayName.next(curUser.displayName);
        }
    }
    login(username: string, password: string, storeid: string) {
        return this.http.post<any>( environment.serverUrl + '/api/StoreEmployee/VerifyUser',
        {
            userID: username,
            userPassword: password,
            workingStoreID: storeid
        })
            .pipe(map((res:any) => {
                // login successful if there's a jwt token in the response
                if (res && res.isSuccess) {
                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({
                        userId: username,
                        employeeId: res.EmployeeID,
                        token: res.userToken,
                        storeId: storeid,
                        region:  res.RuleKeyName,
                        displayName: res.EmployeeName
                    }));
                    this.loggedIn.next(true);
                    this.region.next(res.RuleKeyName);
                    this.employeeDisplayName.next(res.EmployeeName);
                }
                return res;
            }));
    }

    loginAD(username: string, password: string) {
        return this.http.post<any>( environment.serverUrl + '/api/Employee/VerifyUser',
        {
            userID: username,
            password: password
        })
            .pipe(map((res:any) => {
                // login successful if there's a jwt token in the response
                if (res && res.isSuccess) {
                    // store username and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify({
                        userId: username,
                        employeeId: res.EmployeeID,
                        token: res.userToken,
                        displayName: res.EmployeeName ,
                        opsLevel: res.opsLevel,
                        titleID: res.titleID,
                        storeList: res.storeList,
                        opsList: res.opsList,
                        RegionList: res.RegionList,
                        opsId: res.opsID,
                        payrolladmin: res.isPayrollAdmin,
                        payrollsuperadmin: res.isPayrollSuperAdmin,
                        canRequestNew: res.CanRequestNew
                    }));
                    this.loggedIn.next(true);
                    this.region.next('OPS');
                    this.employeeDisplayName.next(res.EmployeeName);
                }
                return res;
            }));
    }

    logout() {
        // remove user from local storage to log user out
        localStorage.removeItem('currentUser');
        this.loggedIn.next(false);
        this.region.next("");
        this.employeeDisplayName.next("");
    }
}
